import { defineNuxtPlugin } from '#app/nuxt'
import { LazyIcons } from '#components'
const lazyGlobalComponents = [
  ["Icons", LazyIcons],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
